import { CheckCircleFilled, CloseCircleFilled, LoadingOutlined } from "@ant-design/icons";
import React from "react";

interface EhrTransferStatusProps {
  status: string;
}

const statusConfig: Record<
  string,
  { icon: React.ReactNode; label: string; sublabel: string; color: string; bg: string; border: string }
> = {
  started: {
    icon: <LoadingOutlined style={{ color: "#6366F1", fontSize: 18 }} spin />,
    label: "Transferring to EHR",
    sublabel: "Your note is being uploaded. This may take a moment...",
    color: "#6366F1",
    bg: "#EEF2FF",
    border: "#C7D2FE",
  },
  completed: {
    icon: <CheckCircleFilled style={{ color: "#10B981", fontSize: 18 }} />,
    label: "Transfer Complete",
    sublabel: "Your note was successfully transferred to your EHR.",
    color: "#059669",
    bg: "#ECFDF5",
    border: "#A7F3D0",
  },
  failed: {
    icon: <CloseCircleFilled style={{ color: "#EF4444", fontSize: 18 }} />,
    label: "Transfer Failed",
    sublabel: "There was an issue. Check MRN/Patient ID and DOB, then try again.",
    color: "#DC2626",
    bg: "#FEF2F2",
    border: "#FECACA",
  },
};

const EhrTransferStatus: React.FC<EhrTransferStatusProps> = ({ status }) => {
  const config = statusConfig[status];
  if (!config) return null;

  return (
    <div
      style={{
        ...styles.container,
        backgroundColor: config.bg,
        borderColor: config.border,
      }}
    >
      <div style={styles.row}>
        {config.icon}
        <div style={styles.textCol}>
          <span style={{ ...styles.label, color: config.color }}>{config.label}</span>
          <span style={styles.sublabel}>{config.sublabel}</span>
        </div>
      </div>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  container: {
    borderRadius: "12px",
    border: "1px solid",
    padding: "12px 14px",
    marginTop: "4px",
  },
  row: {
    display: "flex",
    alignItems: "flex-start",
    gap: "10px",
  },
  textCol: {
    display: "flex",
    flexDirection: "column",
    gap: "2px",
    minWidth: 0,
  },
  label: {
    fontSize: "13px",
    fontWeight: 600,
    lineHeight: "1.3",
  },
  sublabel: {
    fontSize: "12px",
    color: "#6B7280",
    lineHeight: "1.4",
  },
};

export default EhrTransferStatus;
